import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useContext, useMemo } from 'react';
import { getFrontendExperiment, getMutuallyExclusiveExperiment, STATSIG_QUICK_FIND_LAYER } from '@atlassian/search-experiment';

// This ExperimentProvider is used somewhere in Confluence next.
// We will not update this instead, we introduce a new hook for the experiment config.
export var ExperimentProvider = function ExperimentProvider(_ref) {
  var quickFindEnabled = _ref.quickFindEnabled,
    children = _ref.children;
  var layerName = quickFindEnabled ? STATSIG_QUICK_FIND_LAYER : undefined;
  var _useMemo = useMemo(function () {
      return getMutuallyExclusiveExperiment(layerName);
    }, [layerName]),
    backendExperiment = _useMemo.backendExperiment,
    frontendExperiment = _useMemo.frontendExperiment;
  var frontendExperiments;
  if (quickFindEnabled) {
    var exampleFrontendExperiment = getFrontendExperiment({
      abTestId: 'fe_search_experiment'
    });
    var smartlinksExperiment = getFrontendExperiment({
      abTestId: 'smartlinks_in_quickfind'
    });
    frontendExperiments = _objectSpread(_objectSpread({}, (frontendExperiment === null || frontendExperiment === void 0 ? void 0 : frontendExperiment.abTestId) && _defineProperty({}, frontendExperiment.abTestId, frontendExperiment)), {}, _defineProperty(_defineProperty({}, exampleFrontendExperiment.abTestId, exampleFrontendExperiment), smartlinksExperiment.abTestId, smartlinksExperiment));
  }
  return /*#__PURE__*/React.createElement(ExperimentContext.Provider, {
    value: {
      backendExperiment: backendExperiment,
      frontendExperiments: frontendExperiments
    }
  }, children);
};
var ExperimentContext = /*#__PURE__*/React.createContext({
  backendExperiment: undefined,
  frontendExperiments: undefined
});
export var useExperiments = function useExperiments() {
  return useContext(ExperimentContext);
};